// Utility functions

export { cn } from './cn';

// Error utilities
export { throwApiError } from './errorUtils';

// HTML sanitization — required for anything rendered via dangerouslySetInnerHTML
export { sanitizeHtml } from './sanitizeHtml';

// Cache utilities
export { CacheManager, globalCache, withCache, Cached } from './cacheUtils';

// Sources utilities
export { convertSourceFieldToQuestion } from './sourcesUtils';

// Download utilities
export { downloadFile, downloadPDF, downloadExcel, downloadCSV } from './downloadUtils';

// Subscription utilities
export * from './subscriptionUtils';

export const formatString = (str: string): string => {
  const maxLength = 30;
  if (str.length <= maxLength) {
    return str;
  }
  return str.slice(0, maxLength) + '...';
}
// Date utilities
export const formatDate = (date: Date): string => {
  return date.toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
  });
};

export const formatTime = (date: Date): string => {
  return date.toLocaleTimeString('en-US', {
    hour: '2-digit',
    minute: '2-digit',
  });
};

export const formatDateTime = (date: Date): string => {
  return `${formatDate(date)} at ${formatTime(date)}`;
};

// String utilities
export const capitalize = (str: string): string => {
  return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
};

export const slugify = (str: string): string => {
  return str
    .toLowerCase()
    .replace(/[^\w ]+/g, '')
    .replace(/ +/g, '-');
};

// Validation utilities
export const isValidEmail = (email: string): boolean => {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailRegex.test(email);
};

// User utilities
export * from './userUtils';

// Configuration utilities
export * from './sidebarConfig';

// Static data
export { default as navigationData } from './navigationData.json';
export { default as hotelData } from './hotelData.json';
export { default as authData } from './authData.json';
